import React, { useRef, useEffect } from 'react';
import { useInView } from '../../hooks/useInView';
import { useScrollPosition } from '../../hooks/useScrollPosition';

export const Quote = () => {
  const [ref, inView] = useInView();
  const bgRef = useRef(null);
  const scrollY = useScrollPosition();

  useEffect(() => {
    if (bgRef.current) {
      const r = bgRef.current.getBoundingClientRect();
      bgRef.current.style.transform = `translate(-50%, calc(-50% + ${r.top * 0.2}px))`;
    }
  }, [scrollY]);

  return (
    <section className="quote-section" id="about" ref={ref}>
      <div className="quote-bg-text" ref={bgRef}>ПАМЯТЬ</div>
      <p className={`quote-text ${inView ? 'reveal visible' : 'reveal'}`} style={{ transitionDelay: '0.1s' }}>«Фотография — это правда. А правда — это то, что мы забываем, но не можем перестать чувствовать»</p>
      <div className={`quote-author ${inView ? 'reveal visible' : 'reveal'}`} style={{ transitionDelay: '0.2s' }}>— Из архивных записей</div>
    </section>
  );
};